<!-- Main Container -->
<div class="px-4 sm:px-6 lg:px-8 ">
  <!-- Header Section -->
  <div class="sticky top-16 z-10 bg-white w-screen md:w-auto -mx-4 md:mx-0 shadow md:shadow-none">
    <div class="mx-auto max-w-7xl"> 
    <div class="px-4 sm:px-6 lg:px-8 py-4">
      <div class="sm:flex sm:items-center">
        <div class="sm:flex-auto">
          <h1 class="text-xl font-semibold text-gray-900">Vendor Approval</h1>
          <p class="mt-2 text-sm text-gray-700">Review and approve vendor applications for your platform.</p>
        </div>
      </div>
     </div>
    </div>
    <!-- Bottom border for visual separation on desktop -->
    <div class="hidden md:block border-b border-gray-200"></div>
  </div>

  <!-- Table Section -->
  <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
    <div class="mt-8 flow-root">
      <div class="-mx-4 -my-2 sm:mx-0">
        <!-- Desktop Table -->
        <div class="hidden md:block">
          <table class="min-w-full divide-y divide-gray-300">
            <thead>
              <tr>
                <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900">Vendor Name</th>
                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Contact</th>
                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Services</th>
                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Status</th>
                <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-0">
                  <span class="sr-only">Actions</span>
                </th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-200">
              <tr *ngFor="let vendor of pendingVendors" class="hover:bg-gray-50">
                <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900">
                  {{ vendor.vendorName }}
                </td>
                <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                  <div>{{ vendor.contactName }}</div>
                  <div class="text-xs text-gray-400">{{ vendor.phoneNumber | mask: '(000) 000-0000' }}</div>
                  <div class="text-xs text-gray-400">{{ vendor.emailAddress }}</div>
                </td>
                
                <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                  <span class="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">
                    {{ vendor.servicesOffered }}
                  </span>
                </td>
                <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                  <span class="inline-flex items-center rounded-md bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-800 ring-1 ring-inset ring-yellow-600/20">
                    {{ vendor.action }}
                  </span>
                </td>
                <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                  <div class="flex justify-end gap-2">
                    <button (click)="openConfirmModal(vendor, 'approve')" 
                            class="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20 hover:bg-green-100">
                      {{ vendor.isApproved ? 'Resend Invite' : 'Approve' }}
                    </button>
                    <button *ngIf="vendor.isApproved === false" (click)="openConfirmModal(vendor, 'reject')"
                            class="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-600/20 hover:bg-red-100">
                      Reject
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Mobile Cards -->
        <div class="md:hidden space-y-4">
          <div *ngFor="let vendor of pendingVendors" 
              class="bg-white rounded-lg shadow-sm border border-gray-200">
            <div class="p-4 space-y-3">
              <!-- Header -->
              <div class="flex justify-between items-start">
                <div>
                  <h3 class="text-sm font-medium text-gray-900">{{ vendor.vendorName }}</h3>
                  <p class="text-xs text-gray-500 mt-1">Added {{ vendor.createdAt | date:'mediumDate' }}</p>
                </div>
                <span class="inline-flex items-center rounded-md bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-800 ring-1 ring-inset ring-yellow-600/20">
                  {{ vendor.action }}
                </span>
              </div>

              <!-- Details -->
              <div class="border-t border-gray-100 pt-3">
                <dl class="grid grid-cols-2 gap-x-4 gap-y-2 text-sm">
                  <div>
                    <dt class="text-xs text-gray-500">Contact</dt>
                    <dd class="text-gray-900">{{ vendor.contactName }}</dd>
                  </div>
                  <div>
                    <dt class="text-xs text-gray-500">Phone</dt>
                    <dd class="text-gray-900">{{ vendor.phoneNumber | mask: '(000) 000-0000' }}</dd>
                  </div>
                  <div class="col-span-2">
                    <dt class="text-xs text-gray-500">Email</dt>
                    <dd class="text-gray-900">{{ vendor.emailAddress }}</dd>
                  </div>
                  <div class="col-span-2">
                    <dt class="text-xs text-gray-500">Services</dt>
                    <dd class="mt-1">
                      <span class="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10">
                        {{ vendor.servicesOffered }}
                      </span>
                    </dd>
                  </div>
                 
                </dl>
              </div>

              <!-- Actions -->
              <div class="border-t border-gray-100 pt-3 flex gap-2">
                <button (click)="openConfirmModal(vendor, 'approve')" 
                        class="flex-1 rounded-md bg-green-50 px-2 py-1.5 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20 hover:bg-green-100">
                  {{ vendor.isApproved ? 'Resend Invite' : 'Approve' }}
                </button>
                <button *ngIf="vendor.isApproved === false" (click)="openConfirmModal(vendor, 'reject')" 
                        class="flex-1 rounded-md bg-red-50 px-2 py-1.5 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-600/20 hover:bg-red-100">
                  Reject
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Empty State -->
        <div *ngIf="pendingVendors.length === 0" class="text-center py-12">
          <svg class="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
          </svg>
          <h3 class="mt-2 text-sm font-medium text-gray-900">No pending vendors</h3>
          <p class="mt-1 text-sm text-gray-500">There are no vendors waiting for approval at this time.</p>
        </div>
      </div>
    </div>
  </div>
</div>
<lib-confirmation-modal-tw
        [isOpen]="showConfirmModal"
        [type]="modalType"
        [title]="modalType === 'approve' ? 'Approve Vendor' : 'Reject Vendor'"
        [message]="modalType === 'approve' 
            ? 'Are you sure you want to approve ' + (selectedVendor?.vendorName || '') + '? This will grant them access to the system.'
            : 'Are you sure you want to reject ' + (selectedVendor?.vendorName || '') + '? This action cannot be undone.'"
        [confirmButtonText]="modalType === 'approve' ? 'Approve' : 'Reject'"
        (confirm)="handleConfirm()"
        (cancel)="closeModal()"
    ></lib-confirmation-modal-tw>